<template>
  <div class="get-prv-key-wrapper">
    <el-form
      ref="formDate"
      :model="formDate"
      :label-width="`${adaptationVars.formLabelWidth}px`"
      class="demo-ruleForm"
      :rules="editRules"
      label-position="left"
    >
      <el-row>
        <el-col :span="12">
          <el-form-item label="用户身份ID" prop="id">
            <el-input v-model="formDate.id" placeholder="请输入用户身份ID"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item v-if="formDate.mode == 0" label="上级密钥路径" prop="kpath">
            <el-input v-model="formDate.kpath" placeholder="请输入上级密钥路径"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item v-if="formDate.mode == 1" label="主密钥路径" prop="kpath">
            <el-input v-model="formDate.kpath" placeholder="请输入主密钥路径"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="生成密钥方式" prop="mode">
            <el-select v-model="formDate.mode" placeholder="请选择生成密钥方式" class="auto-width">
              <el-option
                v-for="ele in options"
                :key="parseInt(ele.value)"
                :label="ele.label"
                :value="parseInt(ele.value)"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="公司组织ID" prop="orgid">
            <!-- <el-input v-model="formDate.orgid" placeholder="请输入组织ID"></el-input> -->
            <el-select
              v-model="formDate.orgid"
              placeholder="请选择公司组织ID"
              clearable
              disabled
              class="auto-width"
            >
              <el-option
                v-for="item in orgOtion"
                :key="item.OrgId"
                :label="item.OrgName"
                :value="item.OrgId"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="系统参数路径" prop="ppath">
            <el-input v-model="formDate.ppath" placeholder="请输入系统参数路径"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="系统参数根路径" prop="spath">
            <el-input v-model="formDate.spath" placeholder="请输入系统参数根路径"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item>
            <el-button type="primary" @click="handleGetParams()">确定</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import adaptation from '@/mixins/adaptation'
export default {
  name: 'Index',
  mixins: [adaptation],
  adaptationVarsDefine: {
    formLabelWidth: 130
  },
  data() {
    return {
      formDate: {
        id: '',
        kpath: '',
        orgid: '',
        mode: 0,
        ppath: '',
        chain_id: this.$route.query.chainId,
        user_id: String(JSON.parse(localStorage.getItem('cbaas_system_userInfo')).ID),
        spath: ''
      },
      orgOtion: [],
      options: [
        {
          label: '由上级密钥生成',
          value: 0
        },
        {
          label: '由根密钥生成',
          value: 1
        }
      ],
      keyArr: [],
      editRules: {
        id: [{ required: true, message: '请输入用户身份ID', trigger: 'blur' }],
        kpath: [{ required: true, message: '请输入密钥路径', trigger: 'blur' }],
        mode: [{ required: true, message: '请选择生成密钥方式', trigger: 'blur' }],
        orgid: [{ required: true, message: '请选择公司组织ID', trigger: 'blur' }],
        ppath: [{ required: true, message: '请输入系统参数路径', trigger: 'blur' }],
        spath: [{ required: true, message: '请输入系统参数根路径', trigger: 'blur' }]
      },
      adaptationVars: {
        formLabelWidth: 130
      }
    }
  },
  mounted() {
    this.formDate.spath = localStorage.getItem('path')
    this.formDate.orgid = localStorage.getItem('orgid')
    if (localStorage.getItem('keyArr')) {
      this.keyArr = JSON.parse(localStorage.getItem('keyArr'))
    } else {
      this.keyArr = []
    }
    this.getOptions()
  },
  methods: {
    getOptions() {
      this.$apis.chain
        .getChainOrgList({ limit: 1000, offset: 0, chainId: this.$route.query.chainId })
        .then(res => {
          if (res.data && res.data.items) {
            let hasObj = {}
            this.orgOtion = res.data.items.reduce((result, cur) => {
              if (!hasObj[cur.OrgId]) {
                hasObj[cur.OrgId] = true
                result.push(cur)
              }
              return result
            }, [])
          }
        })
    },
    handleGetParams() {
      this.$refs.formDate.validate(valid => {
        if (valid) {
          this.$apis.hibe.genPrvKey(this.formDate).then(res => {
            if (res) {
              if (JSON.parse(localStorage.getItem('keyArr'))) {
                this.keyArr = JSON.parse(localStorage.getItem('keyArr'))
              } else {
                this.keyArr = []
              }
              let obj = { label: this.formDate.id, value: this.removePrefix(res.data) }
              this.keyArr.push(obj)
              localStorage.setItem('keyArr', JSON.stringify(this.keyArr))
              this.$message.success('生成层级密钥成功!')
              this.$emit('getPath')
            }
          })
        }
      })
    },
    removePrefix(str) {
      var colonIndex = str.indexOf(':')

      // 使用substring()方法截取冒号后一位的字符串
      var result = str.substring(colonIndex + 1)

      return result
    }
  }
}
</script>

<style scoped lang="scss">
.get-prv-key-wrapper {
  .el-row {
    margin: 0 calc(0px - var(--base-size-16));

    .el-col {
      padding: 0 var(--base-size-16);
    }
  }
}
</style>
